import * as types from './mutation-types'

export default {
  [types.LOAD_CURRENCIES](state, data) {
    state.currencies = data
  },
  
}
